import { toast } from 'react-toastify';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { subscribeToSaleReminder } from '@api';

import { launchpadProjectKey } from '@query/launchpadProjects';

export const useSubscribeToSaleReminderMutation = (poolId: string, projectId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      subscribeToSaleReminder({
        json: {
          type: 'SALE_POOL_START_REMINDER',
          entityId: poolId,
        },
      }),
    onSuccess: ({ success, message }) => {
      if (success) {
        queryClient.invalidateQueries({ queryKey: launchpadProjectKey.project(projectId, true) });
        return toast.success(message);
      }

      return toast.error(message);
    },
    onError: () => {
      return toast.error('Subscribe to Sale reminder failed.');
    },
  });
};
